import React from 'react';
import {
  expandNamedFilterAction,
  IRowMeta,
  replaceFilterAction,
  setFilterAction,
} from '../../../../redux/slices/oldBuilder';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  activeSchemaIdSelector,
  defaultLogOpsSelector,
} from '../../../../redux/selectors/builder';
import {
  IEventInput,
  IFilterFieldsFragment,
  INamedFilterFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { FilterFields } from '../../../FilterFields';
import { useActionsVisibilityContext } from '../../../ActionsVisibilityContext';

interface IProps {
  rowMeta: IRowMeta;
  filter: IFilterFieldsFragment;
  eventsInput?: IEventInput[];
  maxConditions?: number;
  maxPredicates?: number;
}

const BuilderFilterFields = ({
  rowMeta,
  filter,
  eventsInput,
  maxConditions,
  maxPredicates,
}: IProps) => {
  const dispatch = useAppDispatch();

  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const defaultLogOps = useAppSelector(defaultLogOpsSelector);

  const { hideActions } = useActionsVisibilityContext();

  const submitFilters = (newFilter: IFilterFieldsFragment) => {
    dispatch(
      setFilterAction({
        rowMeta,
        newFilter,
      }),
    );
  };

  const applyCreatedNamedFilter = (namedFilter: INamedFilterFieldsFragment) => {
    dispatch(
      replaceFilterAction({
        rowMeta,
        filter: namedFilter,
      }),
    );
  };

  const expandNamedFilter = () => {
    dispatch(expandNamedFilterAction({ rowMeta }));

    hideActions();
  };

  const removeFilter = () => {
    dispatch(
      setFilterAction({
        rowMeta,
        newFilter: null,
      }),
    );
  };

  return (
    <FilterFields
      rowMeta={rowMeta}
      schemaId={activeSchemaId}
      defaultLogOps={defaultLogOps}
      onSubmit={submitFilters}
      onCreateNamedFilter={applyCreatedNamedFilter}
      onExpandNamedFilter={expandNamedFilter}
      onRemove={removeFilter}
      filter={filter}
      eventsInput={eventsInput}
      maxConditions={maxConditions}
      maxPredicates={maxPredicates}
    />
  );
};

export default BuilderFilterFields;
